import {
  createMuiTheme
} from 'material-ui';
import { getConfig } from '../requesters/implantations'
import { getUrlVars } from '../utils'

export function initializeConfiguration() {
  return new Promise(async (resolve, reject) => {
    getConfig(getUrlVars()['brand']).then((value) => {
      // If autocareEmailHash is passed in url, we use it
      if (getUrlVars()['workshopEmailHash']) {
        value.data.workshopEmailHash =  getUrlVars()['workshopEmailHash']
      }
      window.sessionStorage.setItem("configuration", JSON.stringify(value.data))
      resolve()
    }).catch((reason) => {
      reject(reason)
    })
  })
}

export function configuration() {
  return JSON.parse(window.sessionStorage.getItem("configuration") || "{}")
}

export function muiTheme() {
  return muiThemeCreator(configuration());
}

const muiThemeCreator = (config) => createMuiTheme({
  overrides: {
    MuiButton: {
      flatPrimary: {
        color: config.clientColor,
      }
    },
    MuiPickersToolbar: {
      toolbar: {
        backgroundColor: config.clientColor,
        fontFamily: 'MazdaType-Regular,helvetica,arial,sans-serif !important',
      },
    },
    MuiPickersCalendarHeader: {
      switchHeader: {
        // backgroundColor: lightBlue.A200,
        // color: 'white',
      },
    },
    MuiPickersDay: {
      selected: {
        backgroundColor: config.colorCalendarDaySelected,
        color: '#fff !important',
        '&:hover': {
          backgroundColor: config.colorCalendarDaySelected,
          color: '#fff'
        },
      },
      current: {
        color: config.currentDayCalendarColor ? config.currentDayCalendarColor + '!important' : config.clientColor,
      },
      disabled: {

      }
    },
    MuiPickersModal: {
      dialogAction: {
        color: config.clientColor,
      },
    },
    MuiInput: generateMuiInputProperties(config),
    MuiInputLabel: generateMuiInputLabelProperties(config)
  },
});

function generateMuiInputProperties(config) {
  const properties = config.muiInputStyle ? {
    ...config.muiInputStyle
  } :
    ''
  return properties
}

function generateMuiInputLabelProperties(config) {
  const properties = config.muiInputLabelStyle ? {
    ...config.muiInputLabelStyle
  } :
    ''
  return properties
}


// WEBPACK FOOTER //
// ./src/configuration/index.js